(function sampleSelector() {
  let locked = false;
  let isRendered = false;
  const stateMgr = new StateManager();

  
  locked = true;
  themeVendor.axios.get(`${window.theme.routes.cart}.js`)
    .then(function(response) {
      agSampleSelectorHandler(response.data).then(() => {

       locked = false;
        
      }); 
    });

  document.addEventListener(
    "theme:cart:change",
    async function (event) {
      if (locked === false) {
        locked = true;
        await agSampleSelectorHandler(event.detail.cart);

        locked = false; 
      } 
      
    }.bind(this)
  );

  /////////////The main function /////////////////

  async function agSampleSelectorHandler(cartObj) {

    getSampleSelectors()
      .then(async function (samples) {
        await stateMgr.initState(cartObj, samples);

        const cValidator = new CartValidator();
        cValidator.removeStaleSamplesFromUI(cartObj);

        /**
        * If there are no Live samples but the cart does contain sample items, they are stale.
        Remove from cart and update UI.
        */
        if (samples.length === 0) {
          const sCartItems = cValidator.getSamplesInCart(cartObj);
          if (sCartItems.length > 0) {
            await cValidator.removeSamples(sCartItems);
            dispatchCartUpdateEvt();
            return;
          }
        }

        /*
         * Validate whether user still qualifies for the sample in cart
         */
        for (const sample of samples) {
          if (
            !stateMgr.eligibleSamples.find((id) => sample.master.id === id)
          ) {
            await cValidator.removeIneligibleSample(cartObj, sample);
          }
        }

        if (cValidator.updateCart) {
          dispatchCartUpdateEvt();
          return;
        }

        const ssRenderer = new SampleSelectorRenderer();

         if (isRendered) {
            ssRenderer.updateOnSampleStateChange();
           return;
        }

        if (samples.length === 0  || cartObj.items.length === 0) {  
          return;
        }

        for (const sampleMaster of samples) {
          fetchProducts(sampleMaster)
            .then((products) => {
              const formattedSamples = getFormattedSamples(
                sampleMaster,
                products
              );
              ssRenderer.renderUI(sampleMaster, formattedSamples).then(() => {
                ssRenderer.updateOnSampleStateChange();
                //const sampleItemsEl = document.querySelector(".ag-sample-selector-items");
                // let slider = new themeVendor.Flickity( sampleItemsEl, {
                //     cellAlign: 'left',
                //     wrapAround: true
                // });
              
                // window.setTimeout(function () {
                //   slider.resize();
                // }, 500);
              })
              .catch((err) => {
                console.debug(err);  
              });
              
            });    
        }

        const clickHandlerManager = new ClickHandlerManager();
        clickHandlerManager.addClickListener(cartObj);
      
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  //////////////////////// The following class contains all logic pertaining to rendering the Sample Selectors /////////////////////

  ///Setup constructor function
  function SampleSelectorRenderer() {}
  SampleSelectorRenderer.prototype.renderUI = async function (
    sampleSelector,
    products
  ) {
    return new Promise((resolve, reject) => {    
          
      if (isRendered) {
        resolve();
        return;
      }
      isRendered = true;
      
      const SS_CTR_ID = 'ag-sample-selector-pre-wrapper';       
      
      const isDrawer = isCartDrawer();
      const parentNode = isDrawer ?
        document.querySelector("nav.drawer.cart__drawer .drawer__body") 
        : 
        document.querySelector("form.cart .cart__heading__wrapper");
      
      const observer = new MutationObserver((mutations, obs) => {           
        if (parentNode.querySelector(`#${SS_CTR_ID}`)) {
          obs.disconnect();  
          resolve();
          } 
      });      
      observer.observe(parentNode, { childList: true, subtree: true });

      
      const wrapperEl = $(`<div id='${SS_CTR_ID}'></div>`);
      const containerEl = this.renderContainer(
        sampleSelector.master.id,
        sampleSelector.master.title
      );
      $(wrapperEl).append(containerEl);
      const productsEl = this.renderProducts(sampleSelector.master, products);
      $(containerEl).append(productsEl);
      
      if (isDrawer) {
        const cartWrapperEl = document.querySelector("nav.drawer.cart__drawer .drawer__body");
        $(parentNode).prepend(wrapperEl);
    
      } else {
        $(parentNode).before(wrapperEl);
      }
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    });
  };

  

  SampleSelectorRenderer.prototype.renderContainer = function (
    sampleId,
    sampleTitle
  ) {
    const wrapperEl = $(
      `<div class='ag-sample-selector-wrapper' data-ag_ss_id='${sampleId}'></div>`
    );
    const promptEl = $(
      `<div class='ag-ss-prompt-wrapper'  data-ag_ss_id='${sampleId}'></div>`
    );
    $(wrapperEl).append(promptEl);

    const textEl = $(`<span>${sampleTitle}</span>`);
    $(promptEl).append(textEl);

    const caretEl = $("<span class='ag-ss-caret'> > </span>");
    $(promptEl).append(caretEl);
    return wrapperEl;
  };

  SampleSelectorRenderer.prototype.renderProducts = function (
    sampleMaster,
    products
  ) {
    const wrapperEl = $(
      `<div class='ag-sample-selector-items-wrapper' id='ag-sample-selector-items-wrapper-${sampleMaster.id}' data-state='hide'></div>`
    );

    const ctaEl = this.renderPromptCTA(sampleMaster);
    if (ctaEl) {
      $(wrapperEl).append(ctaEl);
    }
    const ctrEl = $("<div class='ag-sample-selector-items'></div>");
    $(wrapperEl).append(ctrEl);

    products.forEach((p) => {
      const isSelected =
        stateMgr.selectedSamples.find(
          (s) => s.sampleId === p.sampleMasterId && s.variantId === p.variantId
        ) !== undefined;
      let css = "ag-sample-selector-item";

      const itemEl = $(
        `<div class='${css}' data-variant_id='${p.variantId}' data-ag_ss_id=${p.sampleMasterId}></div>`
      );

      const imgEl = $(
        `<img src='${p.featured_image}' alt='featured image for sample -${p.title}' />`
      );
      $(itemEl).append(imgEl);

      const mobileEl = this.renderMobileUI(p);
      $(itemEl).append(mobileEl);

      const btnText = isSelected ? "Unselect" : "Add";
      const addBtnEl = $(`<button class='button ag-ss-add-sample-btn'
        data-sample_id='${p.sampleId}'
        data-variant_id=${p.variantId}
        data-sample_price='${p.samplePrice}'
        data-qty='${p.qty}'
        data-price_code='${p.priceCode}'
        data-product_class='${p.productClass}'>${btnText}
        </button>`);
      $(itemEl).append(addBtnEl);

      const formattedPrice = (p.price / 100).toFixed(2);
      const viewLargerBtn = $(`<button class='button ag-ss-view-lg-btn' 
        data-title='${p.title}'
        data-product_id='${p.productId}'
        data-price='${formattedPrice}'
        data-desc='${p.description}' 
        data-img='${p.featured_image}'
        data-url='${p.url}'>View Larger</button>`);
      $(itemEl).append(viewLargerBtn);

      $(ctrEl).append(itemEl);
    });
    return wrapperEl;
  };


  

  SampleSelectorRenderer.prototype.renderMobileUI = function (product) {
    const wrapperEl = $("<div class='ag-ss-mobile-wrapper'></div>");

    const titleEl = $(`<h2 class='title'>${product.title}</h2>`);
    $(wrapperEl).append(titleEl);

    const ratingEl = this.renderRating(product.productId);
    $(wrapperEl).append(ratingEl);

    const price = product.samplePrice === 0 ? "FREE" : product.samplePrice;
    const priceEl = $(`<h3 class='price'>${price}</h3>`);
    $(wrapperEl).append(priceEl);

    // const descEl = $(`<p class='desc'>${product.description}</p>`);
    // $(wrapperEl).append(descEl);

    return wrapperEl;
  };

  SampleSelectorRenderer.prototype.renderRating = function (productId) {
    const ratingEl = $(`<div class="yotpo bottomLine" style="margin-top:10px"
      data-product-id="${productId}"></div>
      }`);
    return ratingEl;
  };

  SampleSelectorRenderer.prototype.renderPromptCTA = function (sampleMaster) {
    if (
      sampleMaster.callToActionPrompt &&
      sampleMaster.showCallToActionPrompt
    ) {
      const ctaEl = $(`<div class='ag-ss-cta-prompt'>
      <p>${sampleMaster.callToActionPrompt}</p></div>`);
      return ctaEl;
    }
    return null;
  };

  SampleSelectorRenderer.prototype.removeSSNode = function() {
    $("#ag-sample-selector-pre-wrapper").remove();
  }

  SampleSelectorRenderer.prototype.getCartBodyEl = function () {
    const cartWrapperEl = document.querySelector("nav.drawer.cart__drawer");
    const cartBodyEl = cartWrapperEl.querySelector(".drawer__body");
    return cartBodyEl;
  };

  SampleSelectorRenderer.prototype.renderSamplePopup = function (el) {
    const overlayWrapper = $("<div id='ag-popup-overlay'></div>");
    const wrapperEl = $("<div id='ag-ss-lg-wrapper'></div>");

    
    const headerEl = $(
      "<div class='ag-ss-lg-header'></h3>Quick Look</h3> <span class='ag-ss-lg-close-btn'>X</span>"
    );
    $(wrapperEl).append(headerEl);

    const bodyEl = $("<div class='ag-ss-lg-body'></div>");
    $(wrapperEl).append(bodyEl);

    const imgEl = $(
      `<div class='ag-ss-lg-img-wrapper'><img src='${$(el).data(
        "img"
      )}' alt='Image of sample ${$(el).data("title")}' /></div>`
    );
    $(bodyEl).append(imgEl);

    const detailEl = $(
      `<div class='ag-ss-lg-detail-wrapper'><h2>${$(el).data(
        "title"
      )}</h2></div>`
    );
    $(bodyEl).append(detailEl);

    const ratingEl = this.renderRating($(el).data("product_id"));
    $(detailEl).append(ratingEl);

    const priceEl = $(
      `<div class='ag-ss-lg-detail-price'><h4>$${$(el).data(
        "price"
      )}</h4></div>`
    );
    $(detailEl).append(priceEl);

    const descEl = $(
      `<div class='ag-ss-lg-detail-desc'><p>${$(el).data("desc")}</p></div>`
    );
    $(detailEl).append(descEl);

    const promoPriceEl = $(
      `<div class='ag-ss-lg-detail-promo-price'><h4>FREE</h4></div>`
    );
    $(detailEl).append(promoPriceEl);

    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
     
    $("body").append(overlayWrapper);
    $("body").append(wrapperEl);

    document.querySelector("#ag-ss-lg-wrapper").addEventListener("touchmove", function(e) {
      e.stopPropagation();
    }, {passive:false});
    


    
    $(overlayWrapper).fadeIn();
    $(wrapperEl).fadeIn();
  };

  SampleSelectorRenderer.prototype.updateOnSampleStateChange = function () {
    

    $(".ag-sample-selector-wrapper").each(function () {
      const sampleMasterId = $(this).data("ag_ss_id");

      const isEligible = stateMgr.eligibleSamples.find((id) => id === sampleMasterId) !== undefined;
      
      const sampleSelector = stateMgr.sampleSelectors.find((r) => r.master.id == sampleMasterId);

      if (sampleSelector.master.showCallToActionPrompt) {
        const promptEl = $(this).find(".ag-ss-cta-prompt:first");
        if (promptEl) {
          if (isEligible) $(promptEl).hide();
          else $(promptEl).show();
        }
      }

      $(this)
        .find(".ag-sample-selector-item")
        .each(function () {
          const sampleId = $(this).data("ag_ss_id");
          const variantId = $(this).data("variant_id");

          
          const samplesSelected = stateMgr.selectedSamples.filter(
            (r) => r.sampleId === sampleId
          );
          const isSelected = samplesSelected.find(r => r.variantId === variantId) !== undefined;
          const isDisabled = (isEligible === false 
            || stateMgr.isLoading
            || samplesSelected.length >= sampleSelector.master.numberAllowed)
            && isSelected === false;


          if (isDisabled) {
             $(this).addClass("disabled");  
          } else {
            $(this).removeClass("disabled");
          }

          const btnEl = $(this).find(".ag-ss-add-sample-btn:first");
          if (isSelected) {
            $(this).addClass("selected");

            if (stateMgr.isLoading) {
              $(btnEl).text("Loading...");
            } else {
              $(".ag-ss-add-sample-btn-loader").remove();
              $(btnEl).text("unselect");
            }

            if (stateMgr.isLoading === false) {
              $(this).removeClass("disabled");
            }
          } else {
            $(btnEl).text("Add");
            $(this).removeClass("selected");
          }
        });
    });
  };

  //////////////////////////////////////////// End of SampleSelectorRenderer //////////////////////////////////////////

  //////////////////////// The following class contains all logic pertaining to Posting /cart API /////////////////////

  function CartPoster() {}

  CartPoster.prototype.addSelectedSample = function (sampleNode) {
    const sampleObj = this.getObjFromNode(sampleNode);

    const postObj = {
      id: sampleObj.variantId,
      quantity: sampleObj.qty,
      properties: {
        _sampleId: sampleObj.sampleId,
        _customPrice: sampleObj.price * 100,
        _customQty: sampleObj.qty,
        _priceCode: sampleObj.priceCode,
        _productClass: sampleObj.productClass,
      },
    };

    if (
      stateMgr.selectedSamples.find((r) => r.sampleId == sampleObj.sampleId) ===
      false
    ) {
      stateMgr.selectedSamples.push({
        sampleId: sampleObj.sampleId,
        variantId: sampleObj.variantId,
      });
    }
    stateMgr.updateState(true);

    this.postToCart(postObj)
      .then((res) => {
        stateMgr.updateState(false);
        dispatchCartUpdateEvt();
      })
      .catch((err) => {
        stateMgr.updateState(false);
        stateMgr.selectedSamples = stateMgr.selectedSamples.filter(
          (r) => r.sampleId !== sampleObj.sampleId
        );
        console.debug("err is", err);
      });
  };

  CartPoster.prototype.postToCart = function (sample) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.open("POST", window.Shopify.routes.root + "cart/add.js");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        }
      };

      xhr.onerror = reject;

      xhr.send(JSON.stringify(sample));
    });
  };

  CartPoster.prototype.removeSample = function (sampleKey, runUpdateEvt) {
    stateMgr.isLoading = true;
    this.removeFromCart(sampleKey).then((res) => {
      stateMgr.isLoading = false;
      const itemRenderer = new ItemRenderer();
      itemRenderer.removeItem(sampleKey);
    
      if (runUpdateEvt) {
        dispatchCartUpdateEvt();
      }
    });
  };

  CartPoster.prototype.removeFromCart = function (sampleKey) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.open("POST", window.Shopify.routes.root + "cart/change.js");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        }
      };

      xhr.onerror = reject;

      const postObj = {
        id: sampleKey,
        quantity: 0,
      };
      xhr.send(JSON.stringify(postObj));
    });
  };

  CartPoster.prototype.getObjFromNode = function (node) {
    return {
      variantId: $(node).data("variant_id"),
      qty: $(node).data("qty"),
      price: $(node).data("sample_price"),
      productClass: $(node).data("product_class"),
      priceCode: $(node).data("price_code"),
      sampleId: $(node).data("sample_id"),
    };
  };

  ////////////////////////////////////// Class containing all logic pertaining to managing sample state

  function StateManager() {
    this.sampleSelectors = null;
    this.isLoading = false;
    this.selectedSamples = [];
    this.eligibleSamples = []; //array of masterIds of eligible samples

    this.ssRenderer = new SampleSelectorRenderer();
  }

  StateManager.prototype.updateState = function (isLoading) {
    this.isLoading = isLoading;
    this.ssRenderer.updateOnSampleStateChange();
  };

  StateManager.prototype.initState = function (cart, samples) {
    this.sampleSelectors = samples;
    this.isLoading = false;
    this.setSelectedSamples(cart);
    this.setEligibleSamples(cart, samples);


    for (const item of cart.items) {
      if (item.properties["_sampleId"]) {
        const itemEl = document.getElementById(`ag-gwp-key-${item.key}`);
        const existsOnUI = itemEl != null;
        if (existsOnUI == false) {
          const itemRenderer = new ItemRenderer();
          itemRenderer.render(item);
        }
      }
    }
  };


  StateManager.prototype.setSelectedSamples = function (cart) {
    this.selectedSamples = [];
    for (const item of cart.items) {
      if (item.properties["_sampleId"]) {
        this.selectedSamples.push({
          variantId: item.variant_id,
          sampleId: item.properties["_sampleId"],
          cartKey: item.key
        });
      }
    }
  };

  StateManager.prototype.setEligibleSamples = function (cart, samples) {
    this.eligibleSamples = [];

    const cValidator = new CartValidator();
    for (const sample of samples) {
      const isEligible = cValidator.isSampleEligible(sample.master, cart);
      if (isEligible === true) {
        this.eligibleSamples.push(sample.master.id);
      }
    }
  };

  //////////////////////////////////////////// End of StateManager///////////////////////////////////////////////

  /////////////////////////////////// This class is responsibile for validating the samples in cart,

  function CartValidator() {
    this.updateCart = false;
  }

  CartValidator.prototype.removeIneligibleSample = async function (
    cart,
    sample
  ) {
    let sCartItem = null;
    for (const item of cart.items) {
      if (
        item.properties["_sampleId"] &&
        item.properties["_sampleId"] === sample.master.id
      ) {
        sCartItem = item;
        break;
      }
    }

    if (sCartItem) {
      const poster = new CartPoster();
      await poster.removeFromCart(sCartItem.key);

      const itemRenderer = new ItemRenderer();
      itemRenderer.removeItem(sCartItem.key);

      this.updateCart = true;
    }
  };

  CartValidator.prototype.hasSubscriptionItem = function (cart) {
    for (const item of cart.items) {
      if (
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan
      ) {
        return true;
      }
    }
    return false;
  };

  CartValidator.prototype.isSampleEligible = function (sampleMaster, cart) {
    if (
      sampleMaster.isOnlyForSubscribers &&
      this.hasSubscriptionItem(cart) === false
    )
      return false;

    if (this.getCartSubtotalPrice(cart) < sampleMaster.lowerBound) return false;

    return true;
  };

  CartValidator.prototype.getCartSubtotalPrice = function (cart) {
    const donationAmt = this.getDonation(cart); //excude any donation amt if exits
    return (cart.items_subtotal_price - donationAmt) / 100;
  };

  CartValidator.prototype.getDonation = function (cart) {
    let donation = 0;

    for (let i = 0; i < cart.items.length; i++) {
      let item = cart.items[i];

      if (item.sku == "ogc_donate_custom") {
        donation += item.final_line_price;
      }
    }
    return donation;
  };

  CartValidator.prototype.getSamplesInCart = function (cart) {
    const sampleItems = [];
    for (const item of cart.items) {
      if (item.properties["_sampleId"] && item.properties["_sampleId"]) {
        sampleItems.push(item);
      }
    }
    return sampleItems;
  };

  CartValidator.prototype.removeSamples = function (sampleItems) {
    const promises = [];
    return new Promise(function (resolve, reject) {
      const poster = new CartPoster();
      for (const item of sampleItems) {
        if (item.properties["_sampleId"]) {
          const runUpdateEvt = false; //when removing all samples, we run the update evt once all is complete..
          promises.push(poster.removeSample(item.key, runUpdateEvt));
        }
      }
      Promise.all(promises)
        .then((res) => {
          resolve();
        })
        .reject((err) => {
          console.error(err);
        });
    });
  };

  CartValidator.prototype.removeStaleSamplesFromUI = function (cartObj) {
    $(".ag-ss-cart-item").each(function () {
      const sId = $(this).attr("id");
      const sKey = sId.replace("ag-gwp-key-", "");

      let includedInCart = false;
      for (const item of cartObj.items) {
        if (item.key === sKey) {
          includedInCart = true;
          break;
        }
      }
      if (includedInCart === false) {
        const renderer = new ItemRenderer();
        renderer.removeItem(sKey);
      }
    });
  };

  //////////////////////////////////////////////////////

  ////////////////////////////// The following class is responsible for validating

  ///////////////////////////// The following class is responsible for adding/removing sample from cart:
  function ItemRenderer() {}

  ItemRenderer.prototype.removeItem = function (sampleKey) {
    const itemId = `ag-gwp-key-${sampleKey}`;
    const el = document.getElementById(itemId);
    const rootEl = document.querySelector(".cart__items");
    if (el) {
      rootEl.removeChild(el);
    }
  };

  ItemRenderer.prototype.render = function (item) {
    var containerEl = this.buildContainer(item.key);
    var loaderEl = this.buildLoader();
    var itemEl = this.buildItem(item);

    containerEl.appendChild(loaderEl);
    containerEl.appendChild(itemEl);

    document.querySelector(".cart__items").prepend(containerEl);
  };

  ItemRenderer.prototype.buildContainer = function (itemKey) {
    var div = document.createElement("div");
    div.classList.add("cart__items__row");
    div.classList.add("ag-ss-cart-item");
    div.id = `ag-gwp-key-${itemKey}`;
    div.dataset.cartItem = true;

    return div;
  };

  ItemRenderer.prototype.buildLoader = function () {
    var div = document.createElement("div");
    div.classList.add("item--loadbar");
    div.style = "display: none;";
    div.innerHTML = "&nbsp;";

    return div;
  };

  ItemRenderer.prototype.buildItem = function (item) {
    var containerEl = this.buildItemContainer();
    var removeBtn = this.buildRemoveBtn(item);
    $(containerEl).append(removeBtn);
    var imageEl = this.buildImage(item.image, item.title, item.url);
    var titleEl = this.buildTitle(item.product_title, item.url);
    var metaInfoEl = this.buildMetaInfo(item);
    var priceEl = this.buildPrice(item.properties["_customPrice"]);

    const isDrawer = isCartDrawer();
    titleEl.appendChild(metaInfoEl);
    if (isDrawer) {
      titleEl.appendChild(priceEl);
    }
    containerEl.appendChild(imageEl);
    containerEl.appendChild(titleEl);

    if (!isDrawer) {
      containerEl.appendChild(priceEl);
    }
    return containerEl;
  };

  ItemRenderer.prototype.buildItemContainer = function () {
    var div = document.createElement("div");
    div.classList.add("cart__items__grid");
    div.dataset.item = true;

    return div;
  };

  ItemRenderer.prototype.buildRemoveBtn = function (item) {
    const el =
      $(`<span class="cart__items__remove ag_ss_remove_item" data-item_key="${item.key}" tabindex="0">
          <span class="cart__remove__icon ag_ss_remove_item" data-item_key="${item.key}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bin ag_ss_remove_item" data-item_key="${item.key}" viewBox="0 0 11 14"><path d="M10 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V2h9zM9 3H2v9a1 1 0 00.883.993L3 13h5a1 1 0 00.993-.883L9 12V3z"></path><path d="M10.5 2a.5.5 0 110 1H.5a.5.5 0 010-1h10zm-3-2a.5.5 0 010 1h-4a.5.5 0 010-1h4z"></path></svg></span>
          <span class="cart__remove badge">
            Remove
          </span>
        </span>`);

    return el;
  };

  ItemRenderer.prototype.buildImage = function (imgSrc, imgAlt, itemURL) {
    var linkEl = document.createElement("a");
    linkEl.href = itemURL;

    var imgEl = document.createElement("img");
    imgEl.classList.add("cart__items__img");
    imgEl.src = imgSrc;
    imgEl.alt = imgAlt;

    linkEl.appendChild(imgEl);

    return linkEl;
  };

  ItemRenderer.prototype.buildTitle = function (itemTitle, itemURL) {
    var containerEl = document.createElement("div");
    containerEl.classList.add("cart__items__title");

    var pEl = document.createElement("p");
    pEl.innerHTML = `<a href=${itemURL}>${itemTitle}</a>`;

    containerEl.appendChild(pEl);
    return containerEl;
  };

  ItemRenderer.prototype.buildMetaInfo = function (item) {
    if (
      !Array.isArray(item.properties) &&
      typeof item.properties !== "object"
    ) {
      return;
    }

    var withQty = {
      ...item.properties,
      quantity: item.properties["_customQty"],
    };

    var ctrEl = document.createElement("div");
    ctrEl.classList.add("cart__items__meta");

    if (item.variant_title) {
      const smallEl = $(`<p class='small'>${item.variant_title}</p>`);
      $(ctrEl).append(smallEl);
    }

    for (var key in withQty) {
      if (key.charAt(0) === "_") continue;

      var pEl = document.createElement("p");
      pEl.classList.add("small");

      pEl.innerHTML = `<span>${key}: </span> <span>${withQty[key]}</span>`;
      ctrEl.appendChild(pEl);
    }

    return ctrEl;
  };

  ItemRenderer.prototype.buildPrice = function (price) {
    var priceEl = document.createElement("div");
    priceEl.classList.add("cart__items__price");
    priceEl.innerHTML = `<p class='line__price ag_gwp_line__price'>$${price}.00</p>`;

    return priceEl;
  };

  ItemRenderer.prototype.buildQtyEl = function (qty) {
    var qtyEl = document.createElement("div");
    qtyEl.classList.add("cart__items__quantity");

    var wrapperEl = document.createElement("div");
    wrapperEl.classList.add("quantity__wrapper");
    wrapperEl.innerHTML = `<p class='line__price ag_gwp_line__quantity'>${qty}</p>`;
    qtyEl.appendChild(wrapperEl);

    return qtyEl;
  };

  ItemRenderer.prototype.buildItemTotalEl = function (itemTotalCost) {
    var totalEl = document.createElement("div");
    totalEl.classList.add("cart__items__total");
    totalEl.innerHTML = `<p class='line__total ag_gwp_line__total'>$${itemTotalCost}.00</p>`;

    return totalEl;
  };
  //////////////////////////////////////////////////////

  ///////////////////////////////////// This class contains all logic for handling click events in the sample selector app //////////////////////////////

  function ClickHandlerManager() {}

  ClickHandlerManager.prototype.addClickListener = function (cartObj) {
    document.body.addEventListener("click", async (evt) => {
      
      const el = evt.target;


      if (
        $(el).hasClass("ag-ss-prompt-wrapper") ||
        $(el).parent().hasClass("ag-ss-prompt-wrapper")
      ) {
        return;
        evt.preventDefault();
        evt.stopPropagation();
        const sampleId =
          $(el).data("ag_ss_id") || $(el).parent().data("ag_ss_id");

        this.handlePromptClick(el, sampleId);


        // if (!cartObj.attributes || !cartObj.attributes.ag_ss_interaction) {
        //   await markInteractionInCart(cartObj);  
        // } 
        
      } else if ($(el).hasClass("ag-ss-view-lg-btn")) {
        evt.preventDefault();
        evt.stopPropagation();
        new SampleSelectorRenderer().renderSamplePopup(el);
      } else if (
        $(el).hasClass("ag-ss-lg-close-btn") ||
        $(el).is("#ag-popup-overlay")
      ) {
        evt.preventDefault();
        evt.stopPropagation();
        this.handleClosePopupClick();
      } else if (
        $(el).hasClass("ag_ss_remove_item") ||
        $(el).parent().hasClass("ag_ss_remove_item")
      ) {
        evt.preventDefault();
        evt.stopPropagation();

        const itemKey = $(el).data("item_key");
        const poster = new CartPoster();
        poster.removeSample(itemKey, true);
      
      } else if ($(el).hasClass("ag-ss-add-sample-btn")) {
         
        this.handleAddSampleClick(evt, el);
      } else if ($(el).hasClass("drawer__underlay__fill") || $(el).hasClass("drawer__close") || $(el).hasClass("icon-close")) {

        this.handleCartDrawerCloseClick();
      }
    });
  };

  ClickHandlerManager.prototype.handlePromptClick = function (el, sampleId) {
    /**
     * Get ref to the caret el, which could be the el the user clicked on,
     *or from the parent, or the the text sibling
     */
    var caretEl = $(el).hasClass("ag-ss-caret")
      ? el
      : el.querySelector(".ag-ss-caret") || $(el).next();

    const itemsEl = $(`#ag-sample-selector-items-wrapper-${sampleId}`);
    if ($(itemsEl).data("state") === "hide") {
      $(itemsEl).data("state", "show");
      $(itemsEl).slideDown();
      $(caretEl).addClass("caret-show");
    } else {
      $(itemsEl).data("state", "hide");
      $(itemsEl).slideUp();
      $(caretEl).removeClass("caret-show");
    }
  };

  ClickHandlerManager.prototype.handleClosePopupClick = function () {
    $("#ag-popup-overlay").remove();
    $("#ag-ss-lg-wrapper").fadeOut({
      duration: 200,
      complete: function () {
        $("#ag-ss-lg-wrapper").remove();
        $("#ag-popup-overlay").remove();
      },
    });
  };

  ClickHandlerManager.prototype.handleCartDrawerCloseClick = function() {

    $(".ag-sample-selector-items-wrapper").each(function() {
      if ($(this).data("state") === "show") {               
       $(this).data("state", "hide"); 
       $(this).slideUp();
       const cartEl = $(this).prev().find(".ag-ss-caret");
       if (cartEl) {
          $(cartEl).removeClass("caret-show");
       }
     }
    });   
  };


  ClickHandlerManager.prototype.handleAddSampleClick = function(evt, el) {
    evt.preventDefault();
    evt.stopPropagation();
    const sampleId = $(el).data("sample_id");


    const isEligible = stateMgr.eligibleSamples.find((sId) => sId === sampleId) !== undefined;
    if (isEligible === false || stateMgr.isLoading) {
      return;
    }

    

    const variantId = $(el).data("variant_id");
    const selectedSamples = stateMgr.selectedSamples.filter((s) => s.sampleId === sampleId);

    const ALLOWED_SIZE = 2;
    const addedVariant = selectedSamples.find((s) => s.variantId === variantId);

    const ss = stateMgr.sampleSelectors.find((s) => s.master.id === sampleId);
    
    if (!ss) return;
    
    if (selectedSamples.length < ss.master.numberAllowed && addedVariant === undefined) {
       const poster = new CartPoster();
       poster.addSelectedSample(el);  
    } else {
      if (addedVariant) {
        const poster = new CartPoster();
        poster.removeSample(addedVariant.cartKey, true);    
      }
    }
  }


  
  ///////////////////////////////////////////////////////////////END OF ClickHandlerManager////////////////////////////

  /////////////////////////////////////////

  ///////////////////////////////////////// Helper functions /////////////////////////////

  /***
  *@param {samples} array denoting samples that are fetched from our server
  *that the user can select. Contains metadata that we need for further processing

  *@param {products} fetched from Shopify's AJAX api
  */
  function getFormattedSamples(sample, products) {
    const arr = [];

    for (const s of sample.details) {
      for (const p of products) {
        if (!p) continue;
        const variant = p.variants.find((r) => r.id === s.productVariantId);
        if (!variant) continue;

        arr.push({
          sampleMasterId: sample.master.id,
          variantId: variant.id,
          productId: p.id,
          title: variant.name,
          variant_title: variant.title,
          price: variant.price,
          featured_image: variant.featured_image
            ? variant.featured_image.src
            : p.featured_image,
          description: p.description,
          product_title: p.title,
          url: p.url,
          sampleId: sample.master.id, 
          samplePrice: s.price,
          priceCode: s.priceCode,
          productClass: s.productClass,
          qty: s.qty,
        });
      }
    }

    return arr;
  }

  function fetchProducts(samples) {
    return new Promise(function (resolve, reject) {
      var promises = [];
      samples.details.forEach((s) => {
        promises.push(fetchProduct(s.productHandle));
      });

      Promise.all(promises)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          resolve(null);
          console.error(err);
        });
    });
  }

  function fetchProduct(handle) {
    return new Promise(function (resolve, reject) {
      const url = window.Shopify.routes.root + "products/" + handle + ".js";

      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        if (xhr.status === 200) {
          resolve(JSON.parse(this.responseText));  
        } else {
          
          console.error(this.responseText);
          resolve(null);
        }
        
      };
      xhr.onerror = reject;
      xhr.open("GET", url);
      xhr.send();
    });
  }


  // async function markInteractionInCart(cart) {


  //   console.log("marking cart interaction...");
  //   locked = true;
  //   if (!cart.attributes) {
  //     cart.attributes = {};
  //   }
  //   const updatedAttr = {
  //     attributes: {
  //       ag_ss_interaction: true,
  //       ...cart.attributes  
  //     }
  //   }
    
  //   fetch(window.Shopify.routes.root + 'cart/update.js', {
  //     method: 'POST',
  //     headers: {              
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(updatedAttr)
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     locked = false;
  //     document.dispatchEvent(
  //         new CustomEvent("theme:cart:change", {
  //           detail: {
  //             cart: data,
  //           },
  //           bubbles: true,
  //         })
  //       );
      
  //   });
  // }


  function getSampleSelectors() {
    const storecode = "CA";
    return new Promise(function (resolve, reject) {
      if (stateMgr.sampleSelectors !== null) {
        return resolve(stateMgr.sampleSelectors);
      }

      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const data = JSON.parse(this.responseText);
        resolve(data);
      };
      xhr.onerror = reject;
      xhr.open("GET", `https://shopifyapp.aghair.com/api/SampleSelector?storecode=${storecode}`);
      xhr.send();
    });
  }

  function dispatchCartUpdateEvt() {
    themeVendor.axios
      .get(`${window.theme.routes.cart}.js`)
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function isCartDrawer() {

    const drawerCart = document.getElementById("drawer-cart");
    if (drawerCart) return true;
    else return false;
    
  }
})();
